import React from 'react';
import { ClockIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { incluyeOferta } from '../data/content';
export function Pricing() {
  return <section id="precio" className="w-full bg-white" aria-labelledby="precio-titulo" data-id="element-111" data-mp="2ohe5m6lf2fb4">
      <div className="mx-auto max-w-3xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-112" data-mp="2jjcqfwr4304x">
        <h2 id="precio-titulo" className="font-display text-center text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-113" data-mp="1vts371nxdgpu">
          Ordena tu Airbnb hoy y empieza a aplicar el sistema en minutos
        </h2>

        <div className="mt-6 rounded-2xl border-2 border-brand bg-white p-5 shadow-price sm:p-8" data-id="element-114" data-mp="25t0utnvbij91">
          <div className="hidden flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:flex sm:justify-between" data-id="element-115" data-mp="20sd4z5its8ge">
            <p className="inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-brand-dark" data-id="element-116" data-mp="3h5jriwo7iacj">
              <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-117" data-mp="3vzgtfsd9x8yv" />
              El precio de lanzamiento cierra en
            </p>
            <Countdown seconds={3 * 3600 + 4 * 60 + 46} compact data-id="element-118" data-mp="4scn6zoydqri" />
          </div>

          <div className="text-center sm:mt-5 sm:border-t sm:border-surface-line sm:pt-5" data-id="element-119" data-mp="9siak3o6wr3s">
            <p className="font-display text-lg leading-tight text-ink-strong sm:text-2xl" data-id="element-120" data-mp="er1w42yvg0vm">
              MEGAPACK HOST AUTOMÁTICO™
            </p>
            <p className="mt-3 text-sm font-semibold text-ink-muted" data-id="element-121" data-mp="3daik3n9e94ji">
              Precio original:{' '}
              <span className="line-through decoration-brand decoration-2" data-id="element-122" data-mp="3i8k5ieualfy5">
                USD $192
              </span>
            </p>
            <p className="mt-1 flex items-end justify-center gap-2" data-id="element-123" data-mp="3rxv95lyetsen">
              <span className="font-display text-6xl leading-none text-ink-strong sm:text-7xl" data-id="element-124" data-mp="3rz6cxlruv05r">
                $19
              </span>
              <span className="font-display pb-1.5 text-xl leading-none text-ink-muted" data-id="element-125" data-mp="2zhau200yoh3x">
                USD
              </span>
            </p>

            <div className="mx-auto mt-5 max-w-sm" data-id="element-126" data-mp="2rfa5bofdidfv">
              <CTAButton label="Quiero mi Airbnb automatizado" size="lg" fullWidth href="https://sistema-anfitrion-pro.impultienda.ar/checkout" data-id="element-127" data-mp="2mi1jndv0nr9v" />
            </div>
            <p className="mt-3 text-[11px] font-semibold leading-snug text-ink-muted sm:text-xs" data-id="element-128" data-mp="2w8wc4zyuvn3r">
              Pago único · Sin suscripciones · Acceso inmediato · Pagas en tu
              moneda local
            </p>
          </div>

          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-surface-line pt-5" data-id="element-129" data-mp="23la85qlpuggd">
            {incluyeOferta.map(item => <li key={item} className="flex items-start gap-2" data-id="element-130" data-mp="2dg23sovqmt8i">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-131" data-mp="3tvbpbpk91yli" />
                <span className="text-[12px] font-medium leading-snug text-ink sm:text-sm" data-id="element-132" data-mp="3oyl9n3ccx50m">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}